import { render, staticRenderFns } from "./ApplicationTemplateSelectTab.vue?vue&type=template&id=ef458450&scoped=true&lang=pug"
import script from "./ApplicationTemplateSelectTab.vue?vue&type=script&lang=ts"
export * from "./ApplicationTemplateSelectTab.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationTemplateSelectTab.vue?vue&type=style&index=0&id=ef458450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef458450",
  null
  
)

export default component.exports